<app-error-code code="500" [title]="'Server went wrong!'"
    [message]="'Just kidding, looks like we have an internal issue, please try refreshing.'">
</app-error-code>